import React from 'react';
import Icon from '../../../components/AppIcon';

const MatchActivityFeed = ({ logs, currentLanguage }) => {
  const translations = {
    en: {
      title: 'Live Matching Activity',
      noActivity: 'No matching activity in selected time range',
      matchScore: 'Match Score',
      candidates: 'Candidates',
      mode: 'Mode',
      executionTime: 'Execution Time',
      ms: 'ms'
    },
    ko: {
      title: '실시간 매칭 활동',
      noActivity: '선택한 시간 범위에 매칭 활동이 없습니다',
      matchScore: '매칭 점수',
      candidates: '후보자',
      mode: '모드',
      executionTime: '실행 시간',
      ms: '밀리초'
    }
  };

  const t = translations?.[currentLanguage];

  const getModeColor = (mode) => {
    const colors = {
      COST: 'text-success bg-success/10',
      MARGIN: 'text-primary bg-primary/10',
      SPEED: 'text-warning bg-warning/10',
      BALANCED: 'text-accent bg-accent/10'
    };
    return colors?.[mode] || 'text-muted bg-muted/10';
  };

  const getScoreColor = (score) => {
    if (score >= 0.8) return 'text-success';
    if (score >= 0.6) return 'text-warning';
    return 'text-error';
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-md p-4">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Activity" size={20} className="text-primary" />
        <h2 className="text-lg font-semibold text-foreground">{t?.title}</h2>
        <div className="ml-auto w-2 h-2 bg-success rounded-full animate-pulse" />
      </div>

      <div className="space-y-3 max-h-[500px] overflow-y-auto">
        {logs?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="Inbox" size={48} className="text-muted-foreground mx-auto mb-2" />
            <p className="text-sm text-muted-foreground">{t?.noActivity}</p>
          </div>
        ) : (
          logs?.map((log) => (
            <div
              key={log?.id}
              className="border border-border rounded-lg p-3 hover:bg-accent/5 transition-base"
            >
              <div className="flex items-start justify-between mb-2">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
                    <Icon name="Zap" size={16} className="text-primary" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground">
                      Request #{log?.requestId?.slice(0, 8)}
                    </p>
                    <p className="text-xs text-muted-foreground">
                      {new Date(log?.createdAt)?.toLocaleString(currentLanguage === 'ko' ? 'ko-KR' : 'en-US')}
                    </p>
                  </div>
                </div>
                <span className={`px-2 py-1 rounded text-xs font-medium ${getModeColor(log?.matchingMode)}`}>
                  {log?.matchingMode}
                </span>
              </div>

              <div className="grid grid-cols-3 gap-2 mb-2">
                <div>
                  <p className="text-xs text-muted-foreground">{t?.matchScore}</p>
                  <p className={`text-sm font-bold ${getScoreColor(log?.matchScore)}`}>
                    {(log?.matchScore * 100)?.toFixed(0)}%
                  </p>
                </div>
                <div>
                  <p className="text-xs text-muted-foreground">{t?.candidates}</p>
                  <p className="text-sm font-bold text-foreground">{log?.candidatesCount}</p>
                </div>
                <div>
                  <p className="text-xs text-muted-foreground">{t?.executionTime}</p>
                  <p className="text-sm font-bold text-foreground">{log?.executionTimeMs}{t?.ms}</p>
                </div>
              </div>

              <div className="w-full bg-muted/30 rounded-full h-2">
                <div
                  className={`h-2 rounded-full transition-all ${getScoreColor(log?.matchScore)?.replace('text-', 'bg-')}`}
                  style={{ width: `${(log?.matchScore * 100)?.toFixed(0)}%` }}
                />
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default MatchActivityFeed;